import { render, staticRenderFns } from "./Codelist.vue?vue&type=template&id=28fedf88&"
import script from "./Codelist.vue?vue&type=script&lang=js&"
export * from "./Codelist.vue?vue&type=script&lang=js&"
import style0 from "./Codelist.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports